import {
    AdditionDrinksTypes,
    ArtistPerformanceTypes,
    FormMessageTypes,
    FormTypes,
    HotelLevelTypes,
    MealTypes,
    NatureFunDayTypes,
    SpecialRequestStayTypes,
    StayingRequestTypes,
    VisitorsTypes,
} from "./enums";

export class CreateFunDayRequest {
    clientName = "";
    mobile = "";
    email = "";
    goalOfFunDay = "";
    numberOfParticipants: number | null = null;
    desiredRegionOneId: number | null = null;
    desiredRegionTwoId: number | null = null;
    desiredRegionThreeId: number | null = null;
    budgetPerEmployee = "";
    familyBudget = "";
    budgetForCouple = "";
    budgetComments = "";
    requestedFrom: string | null = null;
    requestedTo: string | null = null;
    alternativeHolidayDateOne: string | null = "";
    alternativeHolidayDateTwo: string | null = "";
    alternativeHolidayDateThree: string | null = "";
    alternativeHolidayDateComments = "";
    visitors: VisitorsTypes | null = null;
    needBus = true;
    needGuide = true;
    natureFunDayType: string | null = null;
    natureFunDayComments = "";
    wantIncorporateLectureRecognition = true;
    incorporateLectureRecognitionBudget = "";
    incorporateLectureRecognitionComments = "";
    mealType: string | null = null;
    mealComments = "";
}

export class CreateGroupOrderRequest {
    messageTypes: FormMessageTypes | null = null;
    groupName = "";
    mobile = "";
    email = "";
    purposeOfVacation = "";
    numberRoomsDesired: number | null = null;
    desiredRegionOneId: number | null = null;
    desiredRegionTwoId: number | null = null;
    desiredRegionThreeId: number | null = null;
    budgetPerEmployee = "";
    familyBudget = "";
    budgetForCouple = "";
    budgetComments = "";
    stayingRequestType: string | null = null;
    stayingRequestComments = "";
    hotelLevelType: string | null = null;
    visitors: VisitorsTypes | null = null;
    needBus = true;
    needGuide = true;
    mealType: string | null = null;
    mealComments = "";
    interestedTrip = true;
    interestedTripBudget = "";
    interestedTripComments = "";
    wantIncorporateLectureRecognition = true;
    incorporateLectureRecognitionBudget = "";
    incorporateLectureRecognitionComments = "";
    alternativeHolidayDateOne: string | null = "";
    alternativeHolidayDateTwo: string | null = "";
    alternativeHolidayDateThree: string | null = "";
    alternativeHolidayDateComments = "";
    interestedArtist = true;
    specialRequestStayType: string | null = null;
    eveningArtistBudget = "";
    generalBudget = "";
    additionDrinksOnEvent = true;
    additionDrinksType: string | null = null;
    additionDrinksComments = "";
    artistPerformanceType: ArtistPerformanceTypes | null = null;
    artistPerformanceComments = "";
    additionCoffeeCake = true;
    additionCoffeeCakeComments = "";
    otherEventsNeeded = true;
    otherEventsNeededComments = "";
}

export class FormsFilterRequest {
    keywords = "";
    fromDate: string | null = "";
    tillDate: string | null = "";
    formType: FormTypes | null = null;
    orderBy: string = "";
    asc: boolean = false;
    pageIndex = 0;
}

export class FormResponse {
    id = 0;
    username = "";
    dateAndTime = "";
    desiredRegionOne: string | null = null;
    desiredRegionTwo: string | null = null;
    desiredRegionThree: string | null = null;
    formType: FormTypes | null = null;
    clientName = "";
    mobile = "";
    email = "";
    messageType: FormMessageTypes | null = null;
    formGoal = "";
    numberOfParticipants: number | null = null;
    numberRoomsDesired: number | null = null;
    requestedFrom: string | null = null;
    requestedTo: string | null = null;
    alternativeHolidayDateOne: string | null = null;
    alternativeHolidayDateTwo: string | null = null;
    alternativeHolidayDateThree: string | null = null;
    alternativeHolidayDateComments: string | null = null;
    specialRequestComments: string | null = null;
    budgetPerEmployee = 0;
    familyBudget = 0;
    budgetForCouple = 0;
    budgetComments: string | null = null;
    hotelLevelType: HotelLevelTypes | null = null;
    visitors: VisitorsTypes | null = null;
    needBus = false;
    needGuide = false;
    mealType: MealTypes | null = null;
    mealComments: string | null = null;
    natureFunDayType: NatureFunDayTypes | null = null;
    natureFunDayComments: string | null = null;
    stayingRequestType: StayingRequestTypes | null = null;
    stayingRequestComments: string | null = null;
    wantIncorporateLectureRecognition = false;
    incorporateLectureRecognitionBudget: number | null = null;
    incorporateLectureRecognitionComments: string | null = null;
    interestedArtist: boolean | null = null;
    specialRequestStayType: SpecialRequestStayTypes | null = null;
    eveningArtistBudget: number | null = null;
    generalBudget: number | null = null;
    additionDrinksOnEvent: boolean | null = null;
    additionDrinksType: AdditionDrinksTypes | null = null;
    additionDrinksComments: string | null = null;
    artistPerformanceType: ArtistPerformanceTypes | null = null;
    artistPerformanceComments: string | null = null;
    additionCoffeeCake: boolean | null = null;
    additionCoffeeCakeComments: string | null = null;
    otherEventsNeeded: boolean | null = null;
    otherEventsNeededComments: string | null = null;
    interestedTrip: boolean | null = null;
    interestedTripBudget: number | null = null;
    interestedTripComments: string | null = null;
    currencyId = 0;
    unreadMessages: number | null = null;
}

export interface FormsFilterResponse {
    hasNext: boolean;
    rows: FormResponse[];
    total: number;
    totalFilter: number;
}

export interface ChatMessagesResponse {
    chatMessages: ChatMessageResponse[];
}
export class ChatFile {
    chatMessageId: number = 0;
    fileType: string = "";
    fileName: string = "";
    pathUrl: string = "";
}
export class ChatMessageResponse {
    id = 0;
    userId: number | null = null;
    boUserId: number | null = null;
    message: string | null = null;
    createdAt: string | null = null;
    files: ChatFile[] = [];
    read: boolean = false;
}
export class MarkAsReadRequest {
    FormId: number = 0;
    MessageId: number = 0;
}
